import DetailContainer from './detail-container';

export default DetailContainer;
